import React, { useEffect, useState } from 'react';
import Swal from "sweetalert2"
import '../../styles/tarjetaContenedor.css'

import {FaHospitalUser} from 'react-icons/fa';
import {HiOutlineCheckCircle} from 'react-icons/hi';
import { HiOutlineXCircle } from "react-icons/hi";
import {HiOutlinePlusCircle}  from "react-icons/hi";
import { AiFillCaretDown,AiFillCaretUp } from "react-icons/ai";

/**
 * Objetos
 */
//Importación de las funcionalidades del objeto de tipo unidadHospitalaria
import { getUnidadHospitalariaValue } from '../../objects/unidadHospitalaria';
import { updateMedicalCredential,deleteMedicalCredential } from '../../objects/asociado';

/**
 * Componentes
 */
//Componente que contiene el modal que permite dar salida a un paciente
import PacienteModal from './pacienteModal';
//import QrCode from './rrCode';


/**
 * Utilerías
 */
//Utilería que contiene funciones necesarias en la lógica del funcionamiento del sitio
//import { descrifrar } from '../../utils/functions';

/**
 * Componente que contiene la información y funcionalidad asignada a un paciente pendiente de salida de quirófano
 * @param {Object} param0 Recibe un objeto de tipo paciente con su respectiva información y la información de la sesión
 * @returns Component Devuelve el componente con los elementos y funcionalidad requeridos
 */
const PacientePendienteAlta = ({paciente,userLevel,nomHospitalUser,uhList,setPacienteSeleccionado,
    pacienteSeleccionado,pacienteIsRecuperacion,setPacienteIsRecuperacion,pacienteTelefonoIsVisible,
    setPacienteTelefonoIsVisible,pacienteTieneContactos,setPacienteTieneContactos,
    pacienteContactos,setPacienteContactos,name,pacienteUH,setPacienteUH,pacienteIsEspecial,
    setPacienteIsEspecial,isRecuperacionOrigen,setIsRecuperacionOrigen,isMostrarPacientes,
    pacienteUnidadHospitalariaName,setPacienteUnidadHospitalariaName,setIsMostrarUsuarios,
    setAsociado,setDocumentoSeleccionado,setIsMostrarCredencial,uhSelected,isReadOnly}) => {
    
    //Estado que almacena la información del paciente
    const {UnidadHospitalaria} = paciente;
    //Estado que almacena si el paciente pertenece al tipo de asignación del usuario logeado
    const [isAsignacion,setIsAsignacion]=useState(false)
    //Estado que almacena si el paciente se encuentra en etapa de recuperación
    const [isRecuperacion, setIsRecuperacion] = useState(false)
    //Estado que almacena si el modal de dar salida es visible
    const [isVisible, setIsVisible] = useState(false)
    //Estado que almacen la clase asignada a la tarjeta de paciente
    const [modalClassName,setModalClassName] = useState("")
    //Estado que almacena si el paciente cuenta con lista de contactos
    const [tieneContactos,setTieneContactos] = useState(false)

    const [constanciaUnoName,setConstanciaUnoName] = useState("")
    const [mostrarSelectorImagenConstanciaUno, setMostrarSelectorImagenConstanciaUno] = useState(false)

    const [constanciaDosName,setConstanciaDosName] = useState("")
    const [mostrarSelectorImagenConstanciaDos, setMostrarSelectorImagenConstanciaDos] = useState(false)

    const [constanciaTresName,setConstanciaTresName] = useState("")
    const [mostrarSelectorImagenConstanciaTres, setMostrarSelectorImagenConstanciaTres] = useState(false)

    const [constanciaCuatroName,setConstanciaCuatroName] = useState("")
    const [mostrarSelectorImagenConstanciaCuatro, setMostrarSelectorImagenConstanciaCuatro] = useState(false)

    const [constanciaCincoName,setConstanciaCincoName] = useState("")
    const [mostrarSelectorImagenConstanciaCinco, setMostrarSelectorImagenConstanciaCinco] = useState(false)

    const [gender,setGender] = useState("")

    const [clicContanciasSelect,setClicContanciasSelect] = useState(false)
    const [clicDocPersonalesSelect,setClicDocPersonalesSelect] = useState(false)
    const [clicDocProfesionalesSelect,setClicDocProfesionalesSelect] = useState(false)
    const [puedeEditar,setPuedeEditar] = useState(true)

    //Estilo asignado al icono de la tarjeta para pacientes en quirófano
    const styleActive = { color: "black", margin: "5px auto 5px", height: "25px", fontSize:"3.0em"}
    //Estilo asignado al icono de la tarjeta para pacientes en recuperación
    const styleRecuperacion = { color: "#FFBF00", margin: "5px auto 5px", height: "25px", fontSize:"3.0em"}

    useEffect(()=>{
        if(paciente){//Se verifica que se haya seleccionado un paciente
            let five = new Date().getFullYear();
            let four = five -1;
            let three = four -1;
            let two = three - 1
            let one = two - 1
            setConstanciaUnoName(one)
            setConstanciaDosName(two)
            setConstanciaTresName(three)
            setConstanciaCuatroName(four)
            setConstanciaCincoName(five)
            for(let i=0;i<paciente.contancies.length;i++){
                if(one === paciente.contancies[i].year){
                    setMostrarSelectorImagenConstanciaUno(paciente.contancies[i].sendig)
                }

                if(two === paciente.contancies[i].year){
                    setMostrarSelectorImagenConstanciaDos(paciente.contancies[i].sendig)
                }

                if(three === paciente.contancies[i].year){
                    setMostrarSelectorImagenConstanciaTres(paciente.contancies[i].sendig)
                }

                if(four === paciente.contancies[i].year){
                    setMostrarSelectorImagenConstanciaCuatro(paciente.contancies[i].sendig)
                }

                if(five === paciente.contancies[i].year){
                    setMostrarSelectorImagenConstanciaCinco(paciente.contancies[i].sendig)
                }

            }

            if(paciente.active){//Se verifica si el estatus del paciente es Recuperación
                //console.log(paciente)
                if(isMostrarPacientes){
                    if(userLevel === 'superuser'){
                        if(uhSelected === "General"){
                            setIsAsignacion(true)
                            setPuedeEditar(true)
                        }
                        else{
                            if(uhSelected === paciente.hospital){
                                setIsAsignacion(true)
                                setPuedeEditar(true)
                            }
                            else{
                                setIsAsignacion(false)
                            }
                        }
                    }
                    else{
                        if(nomHospitalUser === paciente.hospital){
                            setIsAsignacion(true)
                            setPuedeEditar(true)
                        }
                        else{
                            if(nomHospitalUser === "MAC Aguascalientes Sur" || nomHospitalUser === "MAC Aguascalientes Norte"){
                                if(paciente.hospital === "MAC Aguascalientes Sur" || paciente.hospital === "MAC Aguascalientes Norte"){
                                    setIsAsignacion(true)
                                    setPuedeEditar(false)
                                }
                                else{
                                    setIsAsignacion(false)
                                }
                            }
                            else{
                                setIsAsignacion(false)
                            }
                        }
                        
                    }
                }
                else{
                    setIsAsignacion(false)
                }
            }
            else{
                if(isMostrarPacientes){
                    setIsAsignacion(false)
                }
                else{
                    if(userLevel === 'superuser'){
                        setIsAsignacion(true)
                    }
                    else{
                        if(nomHospitalUser === paciente.hospital){
                            setIsAsignacion(true)
                        }
                        else{
                            setIsAsignacion(false)
                        }
                    }
                    
                }
            }
            //setTieneContactos
            if(paciente.specialty_array){
                if(paciente.specialty_array.length > 1){
                    setTieneContactos(true)
                }
                else{
                    setTieneContactos(false)
                }
            }
            else{
                setTieneContactos(false)
            }

            if(paciente.gender === "1"){
                setGender("")
            }
            else{
                setGender("")
            }
        }
        else{//Se limpian los estados
            setIsRecuperacion(false)
            setPacienteIsRecuperacion(false)
        }
    },[paciente,setPacienteIsRecuperacion,setPacienteIsEspecial,userLevel,isMostrarPacientes,nomHospitalUser,uhSelected])

    useEffect(()=>{
        if(userLevel === "superuser"){//Verificar si el usuario tiene acceso total a los pacientes
            //Se asigna la clase de tarjeta para la vista de superuser, se indica que se puede mostrar el paciente y se muestra la sección de teléfono de contacto
            setModalClassName("itemblog")
            setPacienteTelefonoIsVisible(true)
            let uhName = getUnidadHospitalariaValue(UnidadHospitalaria)
            setPacienteUH(uhName)
        }
        else{//Usuario de tipo administrador o normal
            setModalClassName("itemblog")
            setPacienteTelefonoIsVisible(true)
            let uhName = getUnidadHospitalariaValue(UnidadHospitalaria)
            setPacienteUH(uhName)
        }
    },[userLevel,nomHospitalUser,UnidadHospitalaria,uhList,setPacienteTelefonoIsVisible,setPacienteUH])

    /**
     * Función que permite ocultar el modal de dar alta
     * @returns Devuelve el estado del objeto
     */
    const hideModal = () => setIsVisible(false);

    const handleActualizarEntregaDocumento = (paciente,opcion,estatus) => (event) => {
        event.preventDefault()
        if(puedeEditar && !isReadOnly){
        let mensaje = ""
        switch(opcion){
            case 1:
                if(estatus){
                    mensaje = "¿Desea confirmar la entrega de la Copia título profesional de " +paciente.name + "?"
                }
                else{
                    mensaje = "¿Desea cancelar la entrega de la Copia título profesional de " +paciente.name + "?"
                }
                break
            case 2:
                if(estatus){
                    mensaje = "¿Desea confirmar la entrega de la Copia cédula profesional de " +paciente.name + "?"
                }
                else{
                    mensaje = "¿Desea cancelar la entrega de la Copia cédula profesional de " +paciente.name + "?"
                }
                break
            case 3:
                if(estatus){
                    mensaje = "¿Desea confirmar la entrega de la Copia cédula especialidad de " +paciente.name + "?"
                }
                else{
                    mensaje = "¿Desea cancelar la entrega de la Copia cédula especialidad de " +paciente.name + "?"
                }
                break
            case 4:
                if(estatus){
                    mensaje = "¿Desea confirmar la entrega de la Copia título especialidad de " +paciente.name + "?"
                }
                else{
                    mensaje = "¿Desea cancelar la entrega de la Copia título especialidad de " +paciente.name + "?"
                }
                break
            case 5:
                if(estatus){
                    mensaje = "¿Desea confirmar la entrega de la Copia título especialidad de " +paciente.name + "?"
                }
                else{
                    mensaje = "¿Desea cancelar la entrega de la Copia título especialidad de " +paciente.name + "?"
                }
                break
            case 6:
                if(estatus){
                    mensaje = "¿Desea confirmar la entrega del Currículum Vitae de " +paciente.name + "?"
                }
                else{
                    mensaje = "¿Desea cancelar la entrega del Currículum Vitae de " +paciente.name + "?"
                }
                break
            case 7:
                if(estatus){
                    mensaje = "¿Desea confirmar la entrega de la Fotografía de " +paciente.name + "?"
                }
                else{
                    mensaje = "¿Desea cancelar la entrega de la Fotografía de " +paciente.name + "?"
                }
                break
            case 8:
                if(estatus){
                    mensaje = "¿Desea confirmar la entrega de la Copia del INE de " +paciente.name + "?"
                }
                else{
                    mensaje = "¿Desea cancelar la entrega de la Copia del INE de " +paciente.name + "?"
                }
                break
            case 9:
                if(estatus){
                    mensaje = "¿Desea confirmar la entrega de la Copia del RFC de " +paciente.name + "?"
                }
                else{
                    mensaje = "¿Desea cancelar la entrega de la Copia del RFC de " +paciente.name + "?"
                }
                break
            case 10:
                if(estatus){
                    mensaje = "¿Desea confirmar la entrega de la Copia del Aviso de funcionamiento de consultorio de " +paciente.name + "?"
                }
                else{
                    mensaje = "¿Desea cancelar la entrega de la Copia del Aviso de funcionamiento de consultorio de " +paciente.name + "?"
                }
                break
            case 11:
                if(estatus){
                    mensaje = "¿Desea confirmar la entrega de la Copia del Registro estatal de profesiones de " +paciente.name + "?"
                }
                else{
                    mensaje = "¿Desea cancelar la entrega de la Copia del Registro estatal de profesiones de " +paciente.name + "?"
                }
                break
            case 12:
                if(estatus){
                    mensaje = "¿Desea confirmar la entrega de la Copia de la Cédula profesional de sub especialidad de " +paciente.name + "?"
                }
                else{
                    mensaje = "¿Desea cancelar la entrega de la Copia de la Cédula profesional de sub especialidad de " +paciente.name + "?"
                }
                break
            case 13:
                if(estatus){
                    mensaje = "¿Desea confirmar la entrega de la Copia de la Certificación de consejo de especialidad de " +paciente.name + "?"
                }
                else{
                    mensaje = "¿Desea cancelar la entrega de la Copia de la Certificación de consejo de especialidad de " +paciente.name + "?"
                }
                break
            case 14:
                if(estatus){
                    mensaje = "¿Desea confirmar la entrega de la Copia de Constancias de cursos o congresos " +  constanciaUnoName + " de " +paciente.name + "?"
                }
                else{
                    mensaje = "¿Desea cancelar la entrega de la Copia de Constancias de cursos o congresos " + constanciaUnoName + " de " +paciente.name + "?"
                }
                break
            case 15:
                if(estatus){
                    mensaje = "¿Desea confirmar la entrega de la Copia de Constancias de cursos o congresos " +  constanciaDosName + " de " +paciente.name + "?"
                }
                else{
                    mensaje = "¿Desea cancelar la entrega de la Copia de Constancias de cursos o congresos " + constanciaDosName + " de " +paciente.name + "?"
                }
                break
            case 16:
                if(estatus){
                    mensaje = "¿Desea confirmar la entrega de la Copia de Constancias de cursos o congresos " +  constanciaTresName + " de " +paciente.name + "?"
                }
                else{
                    mensaje = "¿Desea cancelar la entrega de la Copia de Constancias de cursos o congresos " + constanciaTresName + " de " +paciente.name + "?"
                }
                break
            case 17:
                if(estatus){
                    mensaje = "¿Desea confirmar la entrega de la Copia de Constancias de cursos o congresos " +  constanciaCuatroName + " de " +paciente.name + "?"
                }
                else{
                    mensaje = "¿Desea cancelar la entrega de la Copia de Constancias de cursos o congresos " + constanciaCuatroName + " de " +paciente.name + "?"
                }
                break
            case 18:
                if(estatus){
                    mensaje = "¿Desea confirmar la entrega de la Copia de Constancias de cursos o congresos " +  constanciaCincoName + " de " +paciente.name + "?"
                }
                else{
                    mensaje = "¿Desea cancelar la entrega de la Copia de Constancias de cursos o congresos " + constanciaCincoName + " de " +paciente.name + "?"
                }
                break
            default:
                mensaje = ""
        }
        Swal.fire({
            title: mensaje,
            showDenyButton: false,
            showCancelButton: true,
            confirmButtonColor: '#04afaa',
            confirmButtonText: 'Aceptar',
            denyButtonText: `Cancelar`,
            cancelButtonText:`Cancelar`,
          }).then((result) => {
            if (result.isConfirmed) {
              switch(opcion){
                    case 1:
                        paciente.copy_professional_title = estatus
                        break
                    case 2:
                        paciente.copy_professional_license = estatus
                        break
                    case 3:
                        paciente.copy_specialty_certificate = estatus
                        break
                    case 4:
                        paciente.copy_specialty_title = estatus
                        break
                    case 5:
                        paciente.copy_subspecial_title = estatus
                        break
                    case 6:
                        paciente.curriculum_vitae = estatus
                        break
                    case 7:
                        paciente.photo = estatus
                        break
                    case 8:
                        paciente.ine = estatus
                        break
                    case 9:
                        paciente.rfc = estatus
                        break
                    case 10:
                        paciente.copy_of_office_operating_notice = estatus
                        break
                    case 11:
                        paciente.copy_state_registry_of_professions = estatus
                        break
                    case 12:
                        paciente.copy_subspecialty_professional_certificate = estatus
                        break
                    case 13:
                        paciente.copy_specialty_board_certification = estatus
                        break
                    case 14:
                        paciente.contancies[0].sendig = estatus
                        break
                    case 15:
                        paciente.contancies[1].sendig = estatus
                        break
                    case 16:
                        paciente.contancies[2].sendig = estatus
                        break
                    case 17:
                        paciente.contancies[3].sendig = estatus
                        break
                    case 18:
                        paciente.contancies[4].sendig = estatus
                        break
                    default:
                        mensaje = ""
                }

                let hoy = new Date()
                    if(!paciente.create){
                        paciente.create = hoy.getFullYear()+"-"+(hoy.getMonth()+1)+"-"+hoy.getDate()
                    }

                actualizarCredential()
                async function actualizarCredential(){
                    const response = await updateMedicalCredential(paciente.id,paciente)

                    if(response === "success"){//Actualización de usuario exitosa
                        Swal.fire({
                            icon: 'success',
                            title: 'Credencial actualizada',
                            text: 'Credencial actualizada de manera correcta',
                            confirmButtonText: "Aceptar",
                            confirmButtonColor: "#04afaa",
                          })
                    }
                    else{//Error en la actualización de usuario
                        Swal.fire({
                            icon: 'error',
                            title: 'Error',
                            text: response,
                          })
                    }
                }
            }
          })
        }
    }

    //funcion que abre formulario para actualizar credenciales
    const handleActualizarCredencial = (paciente) => (event) => {
        event.preventDefault()
        console.log(paciente.lastname.toUpperCase()+" "+paciente.name.toUpperCase())
        if(paciente.avisoFuncionamientoExpedidoPor || paciente.avisoFuncionamientoExpiraDay){
            console.log("(Aviso de funcionamiento de consultorio)")
            console.log(paciente.avisoFuncionamientoExpedidoPor.toUpperCase())
            console.log(paciente.avisoFuncionamientoExpiraDay)
        }

        if(paciente.CedulaEspecialidadExpedidoPor || paciente.copiaCedulaEspecialidadExpiraDay){
            console.log("(Cedula especialidad)")
            console.log(paciente.CedulaEspecialidadExpedidoPor.toUpperCase())
            console.log(paciente.copiaCedulaEspecialidadExpiraDay)
        }
        
        if(paciente.CedulaProfesionalExpedidoPor || paciente.copiaCedulaProfesionalExpiraDay){
            console.log("(Cedula profesional)")
            console.log(paciente.CedulaProfesionalExpedidoPor.toUpperCase())
            console.log(paciente.copiaCedulaProfesionalExpiraDay)
        }
        
        if(paciente.copiaTituloSubEspecialidadExpedidoPor || paciente.copiaTituloSubEspecialidadExpiraDay){
            console.log("(Cédula profesional de sub especialidad)")
            console.log(paciente.copiaTituloSubEspecialidadExpedidoPor.toUpperCase())
            console.log(paciente.copiaTituloSubEspecialidadExpiraDay)
        }
        
        if(paciente.certificacionConsejoEspecialidadExpedidoPor || paciente.certificacionConsejoEspecialidadExpiraDay){
            console.log("(Certificación de consejo de especialidad)")
            console.log(paciente.certificacionConsejoEspecialidadExpedidoPor.toUpperCase())
            console.log(paciente.certificacionConsejoEspecialidadExpiraDay)
        }
        
        if(paciente.registroEstatalProfesionalesExpedidoPor || paciente.registroEstatalProfesionalesExpiraDay){
            console.log("(Registro estatal de profesiones)")
            console.log(paciente.registroEstatalProfesionalesExpedidoPor.toUpperCase())
            console.log(paciente.registroEstatalProfesionalesExpiraDay)
        }
        
        if(paciente.copiaTituloEspecialidadExpedidoPor || paciente.copiaTituloEspecialidadExpiraDay){
            console.log("(Título especialidad)")
            console.log(paciente.copiaTituloEspecialidadExpedidoPor.toUpperCase())
            console.log(paciente.copiaTituloEspecialidadExpiraDay)
        }

        if(paciente.tituloProfesionalExpedidoPor || paciente.copiaTituloProfesionalExpiraDay){
            console.log("(Título profesional)")
            console.log(paciente.tituloProfesionalExpedidoPor.toUpperCase())
            console.log(paciente.copiaTituloProfesionalExpiraDay)
        }
        
        if(paciente.copiaTituloSubespecialidadExpedidoPor || paciente.copiaTituloSubespecialidadExpiraDay){
            console.log("(Título subespecialidad)")
            console.log(paciente.copiaTituloSubespecialidadExpedidoPor.toUpperCase())
            console.log(paciente.copiaTituloSubespecialidadExpiraDay)
        }

        if(puedeEditar){
            let activeOpciones = ""
            if(paciente.active){
                activeOpciones += "<option value=1 selected>Vigente</option>"
                activeOpciones += "<option value=2>Inactivo</option>"
            }
            else{
                activeOpciones += "<option value=1>Vigente</option>"
                activeOpciones += "<option value=2 selected>Inactivo</option>"
            }

            let uhOpciones = ""
            uhList.forEach(uh => {
                if(uh.hospital === paciente.hospital){
                    uhOpciones+="<option value="+uh.hospital+" selected>"+uh.hospital+"</option>"
                }
                else{
                    uhOpciones+="<option value="+uh.hospital+">"+uh.hospital+"</option>"
                }
            })

            let especialidadUno = ""
            if(paciente.specialty_array[0]){
                especialidadUno = paciente.specialty_array[0]
            }
            let especialidadDos = ""
            if(paciente.specialty_array[1]){
                especialidadDos = paciente.specialty_array[1]
            }
            let especialidadTres = ""
            if(paciente.specialty_array[2]){
                especialidadTres = paciente.specialty_array[2]
            }

            let cedulaUno = ""
            if(paciente.cedula_array[0]){
                cedulaUno = paciente.cedula_array[0]
            }
            let cedulaDos = ""
            if(paciente.cedula_array[1]){
                cedulaDos = paciente.cedula_array[1]
            }
            let cedulaTres = ""
            if(paciente.cedula_array[2]){
                cedulaTres = paciente.cedula_array[2]
            }
            Swal.fire({
                customClass:'modalRegistro',
                html:`<div class="form_wrapper">
                    <div class="form_container">
                        <div class="row clearfix">
                            <div class="">
                                <form autocomplete="off" method="post">
                                    <h2 class="modalTitle">Editar Asociado `+paciente.identificador+`</h2>
                                    <br />
                                    <div class="input_field">
                                        <p>Nombre del asociado</p>
                                        <input type="text" name="inputNombre" id="inputNombre" placeholder="Ingrese el nombre del asociado" 
                                        required  class="inputText" autocomplete="off"
                                        oninput="this.value=value.replace(/[^a-zA-Z ñÑÁÉÍÓÚáéíóú]/g,'')" value="`+paciente.name+`"/>
                                    </div>
                                    <div class="input_field">
                                        <p>Apellidos del asociado</p>
                                        <input type="text" name="inputApellido" id="inputApellido" placeholder="Ingrese el apellido del asociado" 
                                        required  class="inputText" autocomplete="off"
                                        oninput="this.value=value.replace(/[^a-zA-Z ñÑÁÉÍÓÚáéíóú]/g,'')" value="`+paciente.lastname+`"/>
                                    </div>
                                    <div class="input_field">
                                        <p>CURP del asociado</p>
                                        <input type="text" name="inputCurp" id="inputCurp" placeholder="Ingrese el CURP del asociado" 
                                        required  class="inputText" autocomplete="off"
                                        value="`+paciente.curp+`"/>
                                    </div>
                                    <div class="input_field">
                                        <p>Nombre de especialidad</p>
                                        <input type="text" name="inputEspecialidad" id="inputEspecialidad" placeholder="Ingrese el nombre de especialidad" 
                                        required class="inputText" autocomplete="off"
                                        oninput="this.value=value.replace(/[^a-zA-Z ñÑÁÉÍÓÚáéíóú]/g,'')" value="`+especialidadUno+`"/>
                                    </div>
                                    <div class="input_field">
                                        <p>Cédula de especialidad / Universidad</p>
                                        <input type="text" name="inputCedulaEspecialidad" id="inputCedulaEspecialidad" placeholder="Ingrese la cédula de especialidad y su universidad" 
                                        required class="inputText" autocomplete="off"
                                        value="`+cedulaUno+`"/>
                                    </div>
                                    <div class="input_field">
                                        <p>Nombre de la segunda especialidad</p>
                                        <input type="text" name="inputEspecialidad2" id="inputEspecialidad2" placeholder="Ingrese el nombre de la segunda especialidad" 
                                        required class="inputText" autocomplete="off"
                                        oninput="this.value=value.replace(/[^a-zA-Z ñÑÁÉÍÓÚáéíóú]/g,'')" value="`+especialidadDos+`"/>
                                    </div>
                                    <div class="input_field">
                                        <p>Cédula de la segunda especialidad / Universidad</p>
                                        <input type="text" name="inputCedulaEspecialidad2" id="inputCedulaEspecialidad2" placeholder="Ingrese la cédula de la segunda especialidad y su universidad" 
                                        required class="inputText" autocomplete="off"
                                        value="`+cedulaDos+`"/>
                                    </div>
                                    <div class="input_field">
                                        <p>Nombre de la tercer especialidad</p>
                                        <input type="text" name="inputEspecialidad3" id="inputEspecialidad3" placeholder="Ingrese el nombre de la tercer especialidad" 
                                        required class="inputText" autocomplete="off"
                                        oninput="this.value=value.replace(/[^a-zA-Z ñÑÁÉÍÓÚáéíóú]/g,'')" value="`+especialidadTres+`"/>
                                    </div>
                                    <div class="input_field">
                                        <p>Cédula de la tercer especialidad / Universidad</p>
                                        <input type="text" name="inputCedulaEspecialidad3" id="inputCedulaEspecialidad3" placeholder="Ingrese la cédula de la tercer especialidad y su universidad" 
                                        required class="inputText" autocomplete="off"
                                        value="`+cedulaTres+`"/>
                                    </div>
                                    <div class="input_field">
                                        <p>Nombre de la subespecialidad</p>
                                        <input type="text" name="inputSubEspecialidad" id="inputSubEspecialidad" placeholder="Ingrese el nombre de subespecialidad" 
                                        required class="inputText" autocomplete="off"
                                        oninput="this.value=value.replace(/[^a-zA-Z ñÑÁÉÍÓÚáéíóú]/g,'')" value="`+paciente.subspecialty+`"/>
                                    </div>
                                    
                                    <div class="input_field select_option">
                                        <p>Unidad Hospitalaria</p>
                                        <select id="selectUH">
                                            `+uhOpciones+`
                                        </select>
                                        <div class="select_arrow"></div>
                                    </div>
                                    <div class="input_field select_option">
                                        <select id="selectActive">
                                            `+activeOpciones+`
                                        </select>
                                        <div class="select_arrow"></div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>`,
                showDenyButton: true,
                denyButtonText: "Cancelar",
                denyButtonColor: "grey",
                confirmButtonText: "Aceptar",
                confirmButtonColor: "#04afaa",
                scrollbarPadding:false,
                allowOutsideClick:false,
                width:'500px',
                heightAuto: false,
                focusConfirm: false,
                showCloseButton:true,
                preConfirm: () => {
                    if (document.getElementById('inputNombre').value) {//Se verifica que el campo nombre sea valido
                        if (document.getElementById('inputEspecialidad').value){
                            if (document.getElementById('inputSubEspecialidad').value){
                                if (document.getElementById('inputCurp').value){
                                    let isActive = false
                                    if(document.getElementById('selectActive').value === "1"){
                                        isActive = true
                                    }

                                    var combo = document.getElementById("selectUH");
                                    var selected = combo.options[combo.selectedIndex].text;


                                    if(!paciente.url_copy_professional_title){
                                        paciente.url_copy_professional_title = ''
                                    }
                    
                                    if(!paciente.url_copy_professional_license){
                                        paciente.url_copy_professional_license = ''
                                    }
                    
                                    if(!paciente.url_copy_specialty_certificate){
                                        paciente.url_copy_specialty_certificate = ''
                                    }
                    
                                    if(!paciente.url_copy_specialty_title){
                                        paciente.url_copy_specialty_title = ''
                                    }
                    
                                    if(!paciente.url_copy_subspecial_title){
                                        paciente.url_copy_subspecial_title = ''
                                    }
                    
                                    if(!paciente.url_curriculum_vitae){
                                        paciente.url_curriculum_vitae = ''
                                    }

                                    if(!paciente.url_photo){
                                        paciente.url_photo = ''
                                    }

                                    paciente.specialty_array[0] = document.getElementById('inputEspecialidad').value
                                    paciente.specialty_array[1] = document.getElementById('inputEspecialidad2').value
                                    paciente.specialty_array[2] = document.getElementById('inputEspecialidad3').value

                                    paciente.cedula_array[0] = document.getElementById('inputCedulaEspecialidad').value
                                    paciente.cedula_array[1] = document.getElementById('inputCedulaEspecialidad2').value
                                    paciente.cedula_array[2] = document.getElementById('inputCedulaEspecialidad3').value

                                    if(!paciente.basefotografia){
                                        paciente.basefotografia = ''
                                    }

                                    if(!paciente.baseine){
                                        paciente.baseine = ''
                                    }

                                    if(!paciente.baserfc){
                                        paciente.baserfc = ''
                                    }

                                    if(!paciente.baseCv){
                                        paciente.baseCv = ''
                                    }

                                    if(!paciente.base_copy_professional_title){
                                        paciente.base_copy_professional_title = ''
                                    }

                                    if(!paciente.base_copy_professional_license){
                                        paciente.base_copy_professional_license = ''
                                    }

                                    if(!paciente.base_copy_specialty_certificate){
                                        paciente.base_copy_specialty_certificate = ''
                                    }

                                    if(!paciente.base_copy_specialty_title){
                                        paciente.base_copy_specialty_title = ''
                                    }

                                    if(!paciente.base_copy_subspecialty_professional_certificate){
                                        paciente.base_copy_subspecialty_professional_certificate = ''
                                    }

                                    if(!paciente.base_copy_subspecial_title){
                                        paciente.base_copy_subspecial_title = ''
                                    }

                                    if(!paciente.base_copy_specialty_board_certification){
                                        paciente.base_copy_specialty_board_certification = ''
                                    }

                                    if(!paciente.base_copy_of_office_operating_notice){
                                        paciente.base_copy_of_office_operating_notice = ''
                                    }

                                    if(!paciente.base_copy_state_registry_of_professions){
                                        paciente.base_copy_state_registry_of_professions = ''
                                    }

                                    if(!paciente.base_contancies_one){
                                        paciente.base_contancies_one = ''
                                    }

                                    if(!paciente.copiaTituloProfesionalDay){
                                        paciente.copiaTituloProfesionalDay = ''
                                    }

                                    if(!paciente.copiaTituloProfesionalExpiraDay){
                                        paciente.copiaTituloProfesionalExpiraDay = ''
                                    }

                                    if(!paciente.tituloProfesionalExpedidoPor){
                                        paciente.tituloProfesionalExpedidoPor = ''
                                    }

                                    if(!paciente.copiaCedulaProfesionalDay){
                                        paciente.copiaCedulaProfesionalDay = ''
                                    }

                                    if(!paciente.copiaCedulaProfesionalExpiraDay){
                                        paciente.copiaCedulaProfesionalExpiraDay = ''
                                    }

                                    if(!paciente.CedulaProfesionalExpedidoPor){
                                        paciente.CedulaProfesionalExpedidoPor = ''
                                    }

                                    if(!paciente.copiaCedulaEspecialidadDay){
                                        paciente.copiaCedulaEspecialidadDay = ''
                                    }

                                    if(!paciente.copiaCedulaEspecialidadExpiraDay){
                                        paciente.copiaCedulaEspecialidadExpiraDay = ''
                                    }

                                    if(!paciente.CedulaEspecialidadExpedidoPor){
                                        paciente.CedulaEspecialidadExpedidoPor = ''
                                    }

                                    if(!paciente.copiaTituloEspecialidadDay){
                                        paciente.copiaTituloEspecialidadDay = ''
                                    }

                                    if(!paciente.copiaTituloEspecialidadExpiraDay){
                                        paciente.copiaTituloEspecialidadExpiraDay = ''
                                    }

                                    if(!paciente.copiaTituloEspecialidadExpedidoPor){
                                        paciente.copiaTituloEspecialidadExpedidoPor = ''
                                    }

                                    if(!paciente.copiaTituloSubEspecialidadDay){
                                        paciente.copiaTituloSubEspecialidadDay = ''
                                    }

                                    if(!paciente.copiaTituloSubEspecialidadExpiraDay){
                                        paciente.copiaTituloSubEspecialidadExpiraDay = ''
                                    }

                                    if(!paciente.copiaTituloSubEspecialidadExpedidoPor){
                                        paciente.copiaTituloSubEspecialidadExpedidoPor = ''
                                    }

                                    if(!paciente.copiaTituloSubespecialidadDay){
                                        paciente.copiaTituloSubespecialidadDay = ''
                                    }

                                    if(!paciente.copiaTituloSubespecialidadExpiraDay){
                                        paciente.copiaTituloSubespecialidadExpiraDay = ''
                                    }

                                    if(!paciente.copiaTituloSubespecialidadExpedidoPor){
                                        paciente.copiaTituloSubespecialidadExpedidoPor = ''
                                    }

                                    if(!paciente.certificacionConsejoEspecialidadDay){
                                        paciente.certificacionConsejoEspecialidadDay = ''
                                    }

                                    if(!paciente.certificacionConsejoEspecialidadExpiraDay){
                                        paciente.certificacionConsejoEspecialidadExpiraDay = ''
                                    }

                                    if(!paciente.certificacionConsejoEspecialidadExpedidoPor){
                                        paciente.certificacionConsejoEspecialidadExpedidoPor = ''
                                    }

                                    if(!paciente.avisoFuncionamientoDay){
                                        paciente.avisoFuncionamientoDay = ''
                                    }

                                    if(!paciente.avisoFuncionamientoExpiraDay){
                                        paciente.avisoFuncionamientoExpiraDay = ''
                                    }

                                    if(!paciente.avisoFuncionamientoExpedidoPor){
                                        paciente.avisoFuncionamientoExpedidoPor = ''
                                    }

                                    if(!paciente.registroEstatalProfesionalesDay){
                                        paciente.registroEstatalProfesionalesDay = ''
                                    }

                                    if(!paciente.registroEstatalProfesionalesExpiraDay){
                                        paciente.registroEstatalProfesionalesExpiraDay = ''
                                    }

                                    if(!paciente.registroEstatalProfesionalesExpedidoPor){
                                        paciente.registroEstatalProfesionalesExpedidoPor = ''
                                    }

                                    let hoy = new Date()
                                    if(!paciente.create){
                                        paciente.create = hoy.getFullYear()+"-"+(hoy.getMonth()+1)+"-"+hoy.getDate()
                                    }
    
                                    let credentialObject = {
                                        "url_copy_specialty_certificate":paciente.url_copy_specialty_certificate,
                                        "url_copy_professional_license":paciente.url_copy_professional_license,
                                        "name":document.getElementById('inputNombre').value,
                                        "url_copy_subspecial_title":paciente.url_copy_subspecial_title,
                                        "url_curriculum_vitae":paciente.url_curriculum_vitae,
                                        "url_copy_professional_title":paciente.url_copy_professional_title,
                                        "status":"Vigente (expediente completo)",
                                        "subspecialty":document.getElementById('inputSubEspecialidad').value,
                                        "url_copy_specialty_title":paciente.url_copy_specialty_title,
                                        "active":isActive,
                                        "specialty":document.getElementById('inputEspecialidad').value,
                                        "curp":document.getElementById('inputCurp').value,
                                        "hospital" : selected,
                                        "copy_specialty_certificate" : paciente.copy_specialty_certificate,
                                        "copy_professional_license" : paciente.copy_professional_license,
                                        "copy_subspecial_title" : paciente.copy_subspecial_title,
                                        "curriculum_vitae" : paciente.curriculum_vitae,
                                        "copy_professional_title" : paciente.copy_professional_title,
                                        "copy_specialty_title" : paciente.copy_specialty_title,
                                        "photo" : paciente.photo,
                                        "url_photo" : paciente.url_photo,
                                        "ine" : paciente.ine,
                                        "url_ine" : paciente.url_ine,
                                        "rfc" : paciente.rfc,
                                        "url_rfc" : paciente.url_rfc,
                                        "copy_of_office_operating_notice" : paciente.copy_of_office_operating_notice,
                                        "url_copy_of_office_operating_notice" : paciente.url_copy_of_office_operating_notice,
                                        "copy_state_registry_of_professions" : paciente.copy_state_registry_of_professions,
                                        "url_copy_state_registry_of_professions" : paciente.url_copy_state_registry_of_professions,
                                        "copy_subspecialty_professional_certificate" : paciente.copy_subspecialty_professional_certificate,
                                        "url_copy_subspecialty_professional_certificate" : paciente.url_copy_subspecialty_professional_certificate,
                                        "copy_specialty_board_certification" : paciente.copy_specialty_board_certification,
                                        "url_copy_specialty_board_certification" : paciente.url_copy_specialty_board_certification,
                                        "contancies" : paciente.contancies,
                                        "gender" : paciente.gender,
                                        "lastname" :  document.getElementById('inputApellido').value,
                                        "specialty_array" : paciente.specialty_array,
                                        "cedula_array" : paciente.cedula_array,
                                        "basefotografia" : paciente.basefotografia,
                                        "baseine" : paciente.baseine,
                                        "baserfc" : paciente.baserfc,
                                        "baseCv" : paciente.baseCv,
                                        "base_copy_professional_title" : paciente.base_copy_professional_title,
                                        "base_copy_professional_license" : paciente.base_copy_professional_license,
                                        "base_copy_specialty_certificate" : paciente.base_copy_specialty_certificate,
                                        "base_copy_specialty_title" : paciente.base_copy_specialty_title,
                                        "base_copy_subspecialty_professional_certificate" : paciente.base_copy_subspecialty_professional_certificate,
                                        "base_copy_subspecial_title" : paciente.base_copy_subspecial_title,
                                        "base_copy_specialty_board_certification" : paciente.base_copy_specialty_board_certification,
                                        "base_copy_of_office_operating_notice" : paciente.base_copy_of_office_operating_notice,
                                        "base_copy_state_registry_of_professions" : paciente.base_copy_state_registry_of_professions,
                                        "base_contancies_one" : "",
                                        "copiaTituloProfesionalDay" : paciente.copiaTituloProfesionalDay,
                                        "copiaTituloProfesionalExpiraDay" : paciente.copiaTituloProfesionalExpiraDay,
                                        "tituloProfesionalExpedidoPor" : paciente.tituloProfesionalExpedidoPor,
                                        "copiaCedulaProfesionalDay" : paciente.copiaCedulaProfesionalDay,
                                        "copiaCedulaProfesionalExpiraDay" : paciente.copiaCedulaProfesionalExpiraDay,
                                        "CedulaProfesionalExpedidoPor" : paciente.CedulaProfesionalExpedidoPor,
                                        "copiaCedulaEspecialidadDay" : paciente.copiaCedulaEspecialidadDay,
                                        "copiaCedulaEspecialidadExpiraDay" : paciente.copiaCedulaEspecialidadExpiraDay,
                                        "CedulaEspecialidadExpedidoPor" : paciente.CedulaEspecialidadExpedidoPor,
                                        "copiaTituloEspecialidadDay" : paciente.copiaTituloEspecialidadDay,
                                        "copiaTituloEspecialidadExpiraDay" : paciente.copiaTituloEspecialidadExpiraDay,
                                        "copiaTituloEspecialidadExpedidoPor" : paciente.copiaTituloEspecialidadExpedidoPor,
                                        "copiaTituloSubEspecialidadDay" : paciente.copiaTituloSubEspecialidadDay,
                                        "copiaTituloSubEspecialidadExpiraDay" : paciente.copiaTituloSubEspecialidadExpiraDay,
                                        "copiaTituloSubEspecialidadExpedidoPor" : paciente.copiaTituloSubEspecialidadExpedidoPor,
                                        "copiaTituloSubespecialidadDay" : paciente.copiaTituloSubespecialidadDay,
                                        "copiaTituloSubespecialidadExpiraDay" : paciente.copiaTituloSubespecialidadExpiraDay,
                                        "copiaTituloSubespecialidadExpedidoPor" : paciente.copiaTituloSubespecialidadExpedidoPor,
                                        "certificacionConsejoEspecialidadDay" : paciente.certificacionConsejoEspecialidadDay,
                                        "certificacionConsejoEspecialidadExpiraDay" : paciente.certificacionConsejoEspecialidadExpiraDay,
                                        "certificacionConsejoEspecialidadExpedidoPor" : paciente.certificacionConsejoEspecialidadExpedidoPor,
                                        "avisoFuncionamientoDay" : paciente.avisoFuncionamientoDay,
                                        "avisoFuncionamientoExpiraDay" : paciente.avisoFuncionamientoExpiraDay,
                                        "avisoFuncionamientoExpedidoPor" : paciente.avisoFuncionamientoExpedidoPor,
                                        "registroEstatalProfesionalesDay" : paciente.registroEstatalProfesionalesDay,
                                        "registroEstatalProfesionalesExpiraDay" : paciente.registroEstatalProfesionalesExpiraDay,
                                        "registroEstatalProfesionalesExpedidoPor" : paciente.registroEstatalProfesionalesExpedidoPor,
                                        "create" : paciente.create
                                    }

                                    solicitarActualizarCredencial()
                                    async function solicitarActualizarCredencial(){
                                        const response = await updateMedicalCredential(paciente.id,credentialObject)

                                        if(response === "success"){//Actualización de usuario exitosa
                                            Swal.fire({
                                                icon: 'success',
                                                title: 'Credencial actualizada',
                                                text: 'Credencial actualizada de manera correcta',
                                                confirmButtonText: "Aceptar",
                                                confirmButtonColor: "#04afaa",
                                            })
                                        }
                                        else{//Error en la actualización de usuario
                                            Swal.fire({
                                                icon: 'error',
                                                title: 'Error',
                                                text: response,
                                            })
                                        }
                                    }
                                }
                                else{
                                    Swal.showValidationMessage('Proporcione el CURP del usuario')   
                                }
                            }
                            else{
                                Swal.showValidationMessage('Proporcione la subespecialidad')   
                            }
                        }
                        else{
                            Swal.showValidationMessage('Proporcione la especialidad')   
                        }
                    } else {//Nombre de usuario invalido
                        Swal.showValidationMessage('Proporcione el nombre del usuario')   
                    }
                }
            })
        }
    }

    const handleVisualizarCredencial = (paciente) => (event) => {
        event.preventDefault()
        setAsociado(paciente)
        setIsMostrarCredencial(true)
    }

    const handleOpenImageView = (paciente,opcion,estatus) => (event) => {
        event.preventDefault()
        setAsociado(paciente)
        setDocumentoSeleccionado(opcion)
        setIsMostrarUsuarios(true)
    }

    /**
     * Función que muestra la lista de contactos que tiene registrada un paciente
     * @returns Devuelve el estado del objeto
     */
    const handleContactosClick = (paciente) => (event) => {
        event.preventDefault()
        let contactos = ""
        contactos += "<h2 class=modalPacienteTitle>Especialidad:</h2>"
        if(paciente.gender === '1'){
            contactos += "<h1 class='info_itemblog'>"+paciente.name+" "+paciente.lastname+"</h1>"
        }
        else{
            contactos += "<h1 class='info_itemblog'>"+paciente.name+" "+paciente.lastname+"</h1>"
        }
        //contactos += "<h1 class='info_itemblog'>"+paciente.name+"</h1>"
        for(let i=0; i< paciente.specialty_array.length;i++){
            contactos += "<h1 class='info_item_fecha'>"+paciente.specialty_array[i]+"</h1>"
        }
        Swal.fire({
            html:
              contactos,
            showCloseButton: true,
            showConfirmButton:false,
            customClass: 'swal-height'
          })
    }

    function mostrarOcultarConstancias(){ 
        if(!clicContanciasSelect){
            setClicDocProfesionalesSelect(false)
            setClicDocPersonalesSelect(false)
            setModalClassName("itemblogConstanscias")
            setClicContanciasSelect(true)
        } else{
            setClicContanciasSelect(false)
            setModalClassName("itemblog")
        }   
    }

    function mostrarOcultarDocPersonales(){ 
        if(!clicDocPersonalesSelect){
            setClicDocProfesionalesSelect(false)
            setClicContanciasSelect(false)
            setModalClassName("itemblogPersonales")
            setClicDocPersonalesSelect(true)
        } else{
            setClicDocPersonalesSelect(false)
            setModalClassName("itemblog")
        }   
    }

    function mostrarOcultarDocProfesionales(){ 
        if(!clicDocProfesionalesSelect){
            setClicDocPersonalesSelect(false)
            setClicContanciasSelect(false)
            setModalClassName("itemblogProfesionales")
            setClicDocProfesionalesSelect(true)
        } else{
            setClicDocProfesionalesSelect(false)
            setModalClassName("itemblog")
        }   
    }

    const handleEliminarCredencial = (paciente) => (event) => {
        event.preventDefault()
        Swal.fire({
            title: "¿Desea eliminar al asociado " + paciente.name + "?",
            showDenyButton: false,
            showCancelButton: true,
            confirmButtonColor: '#04afaa',
            confirmButtonText: 'Aceptar',
            denyButtonText: `Cancelar`,
            cancelButtonText:`Cancelar`,
          }).then((result) => {
            if (result.isConfirmed) {
                eliminarCredential()
                async function eliminarCredential(){
                    const response = await deleteMedicalCredential(paciente.id)

                    if(response === "success"){//Actualización de usuario exitosa
                        Swal.fire({
                            icon: 'success',
                            title: 'Credencial eliminada',
                            text: 'Credencial eliminada de manera correcta',
                            confirmButtonText: "Aceptar",
                            confirmButtonColor: "#04afaa",
                          })
                    }
                    else{//Error en la actualización de usuario
                        Swal.fire({
                            icon: 'error',
                            title: 'Error',
                            text: response,
                          })
                    }
                }
            }
          })
        
    }

    return(
        <>
            {
                (isAsignacion)?
                    (
                        <>
                            <div className={modalClassName}>
                                <div>
                                    {/* <img src="http://hospitalesmac.com/img/icono_9.png" title="Pendiente de salida" alt="Pendiente de salida" height="48px" className='imgservi'/> */}
                                    {
                                        puedeEditar?<FaHospitalUser style={styleActive}/>
                                        :<FaHospitalUser style={styleRecuperacion}/>
                                    }
                                    {/* <h1 className='itemblogTitle'>{paciente.name.toUpperCase()}</h1> */}
                                    <h1 className='info_item_hospital_name'>{paciente.identificador +" "+gender+" "+paciente.name.toUpperCase() + " "+paciente.lastname.toUpperCase()}</h1>
                                    <h1 className='info_itemblog'>CURP: {paciente.curp}</h1>
                                    <div className="input-wrapper">
                                        {
                                            tieneContactos
                                            ?
                                                <HiOutlinePlusCircle className='input-icon-plus' onClick={handleContactosClick(paciente)}/>
                                            :
                                                null
                                        }
                                        <h3 className="input">Especialidad: {paciente.specialty}</h3>
                                    </div>
                                    <h1 className='info_item_fecha'>Subespecialidad: {paciente.subspecialty}</h1>
                                    <h1 className='info_item_fecha'>Unidad: {paciente.hospital}</h1>

                                    <div className="input-wrapper">
                                        {
                                            clicDocPersonalesSelect
                                                ?
                                                    <span id="buildingDownArrow" className="input-icon-drop" onClick={mostrarOcultarDocPersonales}><AiFillCaretUp/></span>
                                                :
                                                    <span id="buildingDownArrow" className="input-icon-drop" onClick={mostrarOcultarDocPersonales}><AiFillCaretDown/></span>
                                        }
                                        <h3 className="input-document-group" >Documentos personales</h3>
                                    </div>
                                        {
                                            clicDocPersonalesSelect
                                                ?
                                                    <>
                                                        <div className="input-wrapper">
                                                            {
                                                                paciente.photo
                                                                ?
                                                                    <>
                                                                        <HiOutlineCheckCircle className='input-icon' onClick={handleActualizarEntregaDocumento(paciente,7,false)}/>
                                                                        <h3 className="input-document" onClick={handleOpenImageView(paciente,7,true)}> Fotografía</h3>
                                                                    </>
                                                                    
                                                                :
                                                                    <>
                                                                        <HiOutlineXCircle className='input-icon-inactive' onClick={handleActualizarEntregaDocumento(paciente,7,true)}/>
                                                                        <h3 className="input-document" onClick={handleOpenImageView(paciente,7,false)}> Fotografía</h3>
                                                                    </>
                                                            }
                                                        </div>
                                                        <div className="input-wrapper">
                                                            {
                                                                paciente.ine
                                                                ?
                                                                    <>
                                                                        <HiOutlineCheckCircle className='input-icon' onClick={handleActualizarEntregaDocumento(paciente,8,false)}/>
                                                                        <h3 className="input-document" onClick={handleOpenImageView(paciente,8,true)}> INE</h3>
                                                                    </>
                                                                    
                                                                :
                                                                    <>
                                                                        <HiOutlineXCircle className='input-icon-inactive' onClick={handleActualizarEntregaDocumento(paciente,8,true)}/>
                                                                        <h3 className="input-document" onClick={handleOpenImageView(paciente,8,false)}> INE</h3>
                                                                    </>
                                                            }
                                                        </div>
                                                        <div className="input-wrapper">
                                                            {
                                                                paciente.rfc
                                                                ?
                                                                    <>
                                                                        <HiOutlineCheckCircle className='input-icon' onClick={handleActualizarEntregaDocumento(paciente,9,false)}/>
                                                                        <h3 className="input-document" onClick={handleOpenImageView(paciente,9,true)}> RFC (Constancia de Situación Fiscal)</h3>
                                                                    </>
                                                                    
                                                                :
                                                                    <>
                                                                        <HiOutlineXCircle className='input-icon-inactive' onClick={handleActualizarEntregaDocumento(paciente,9,true)}/>
                                                                        <h3 className="input-document" onClick={handleOpenImageView(paciente,9,false)}> RFC (Constancia de Situación Fiscal)</h3>
                                                                    </>
                                                            }
                                                        </div>
                                                        <div className="input-wrapper">
                                                            {
                                                                paciente.curriculum_vitae
                                                                    ?
                                                                        <>
                                                                            <HiOutlineCheckCircle className='input-icon' onClick={handleActualizarEntregaDocumento(paciente,6,false)}/>
                                                                            <h3 className="input-document" onClick={handleOpenImageView(paciente,6,true)}>Currículum Vitae</h3>
                                                                        </>
                                                                        
                                                                    :
                                                                        <>
                                                                            <HiOutlineXCircle className='input-icon-inactive' onClick={handleActualizarEntregaDocumento(paciente,6,true)}/>
                                                                            <h3 className="input-document" onClick={handleOpenImageView(paciente,6,false)}>Currículum Vitae</h3>
                                                                        </>
                                                                        
                                                            }
                                                            
                                                        </div>
                                                    </>
                                                :
                                                    null
                                        }
                                    
                                    <div className="input-wrapper">
                                        {
                                            clicDocProfesionalesSelect
                                                ?
                                                    <span id="buildingDownArrow" className="input-icon-drop" onClick={mostrarOcultarDocProfesionales}><AiFillCaretUp/></span>
                                                :
                                                    <span id="buildingDownArrow" className="input-icon-drop" onClick={mostrarOcultarDocProfesionales}><AiFillCaretDown/></span>
                                        }
                                        <h3 className="input-document-group" >Documentos profesionales</h3>
                                    </div>
                                    {
                                            clicDocProfesionalesSelect
                                                ?
                                                    <>
                                                        <div className="input-wrapper">
                                                            {
                                                                paciente.copy_professional_title
                                                                ?
                                                                    <>
                                                                        <HiOutlineCheckCircle className='input-icon' onClick={handleActualizarEntregaDocumento(paciente,1,false)}/>
                                                                        <h3 className="input-document" onClick={handleOpenImageView(paciente,1,true)}> Copia título profesional</h3>
                                                                    </>
                                                                    
                                                                :
                                                                    <>
                                                                        <HiOutlineXCircle className='input-icon-inactive' onClick={handleActualizarEntregaDocumento(paciente,1,true)}/>
                                                                        <h3 className="input-document" onClick={handleOpenImageView(paciente,1,false)}> Copia título profesional</h3>
                                                                    </>
                                                            }
                                                        </div>
                                                        <div className="input-wrapper">
                                                            {
                                                                paciente.copy_professional_license
                                                                ?
                                                                    <>
                                                                        <HiOutlineCheckCircle className='input-icon' onClick={handleActualizarEntregaDocumento(paciente,2,false)}/>
                                                                        <h3 className="input-document" onClick={handleOpenImageView(paciente,2,true)}>Copia cédula profesional</h3>
                                                                    </>
                                                                    
                                                                :
                                                                    <>
                                                                        <HiOutlineXCircle className='input-icon-inactive' onClick={handleActualizarEntregaDocumento(paciente,2,true)}/>
                                                                        <h3 className="input-document" onClick={handleOpenImageView(paciente,2,false)}>Copia cédula profesional</h3>
                                                                    </>
                                                                    
                                                            }
                                                        </div>
                                                        <div className="input-wrapper">
                                                            {
                                                                paciente.copy_specialty_certificate
                                                                ?
                                                                    <>
                                                                        <HiOutlineCheckCircle className='input-icon' onClick={handleActualizarEntregaDocumento(paciente,3,false)}/>
                                                                        <h3 className="input-document" onClick={handleOpenImageView(paciente,3,true)}>Copia cédula especialidad</h3>
                                                                    </>
                                                                    
                                                                :
                                                                    <>
                                                                        <HiOutlineXCircle className='input-icon-inactive' onClick={handleActualizarEntregaDocumento(paciente,3,true)}/>
                                                                        <h3 className="input-document" onClick={handleOpenImageView(paciente,3,false)}>Copia cédula especialidad</h3>
                                                                    </>
                                                            }
                                                            
                                                        </div>
                                                        <div className="input-wrapper">
                                                            {
                                                                paciente.copy_specialty_title
                                                                ?
                                                                    <>
                                                                        <HiOutlineCheckCircle className='input-icon' onClick={handleActualizarEntregaDocumento(paciente,4,false)}/>
                                                                        <h3 className="input-document" onClick={handleOpenImageView(paciente,4,true)}>Copia título especialidad</h3>
                                                                    </>
                                                                    
                                                                :
                                                                    <>
                                                                        <HiOutlineXCircle className='input-icon-inactive' onClick={handleActualizarEntregaDocumento(paciente,4,true)}/>
                                                                        <h3 className="input-document" onClick={handleOpenImageView(paciente,4,false)}>Copia título especialidad</h3>
                                                                    </>
                                                                    
                                                            }
                                                            
                                                        </div>
                                                        <div className="input-wrapper">
                                                            {
                                                                paciente.copy_subspecialty_professional_certificate
                                                                ?
                                                                    <>
                                                                        <HiOutlineCheckCircle className='input-icon' onClick={handleActualizarEntregaDocumento(paciente,12,false)}/>
                                                                        <h3 className="input-document" onClick={handleOpenImageView(paciente,12,true)}>Copia cédula profesional de sub especialidad</h3>
                                                                    </>
                                                                    
                                                                :
                                                                    <>
                                                                        <HiOutlineXCircle className='input-icon-inactive' onClick={handleActualizarEntregaDocumento(paciente,12,true)}/>
                                                                        <h3 className="input-document" onClick={handleOpenImageView(paciente,12,false)}>Copia cédula profesional de sub especialidad</h3>
                                                                    </>
                                                                    
                                                            }
                                                            
                                                        </div>
                                                        <div className="input-wrapper">
                                                            {
                                                                paciente.copy_subspecial_title
                                                                ?
                                                                    <>
                                                                        <HiOutlineCheckCircle className='input-icon' onClick={handleActualizarEntregaDocumento(paciente,5,false)}/>
                                                                        <h3 className="input-document" onClick={handleOpenImageView(paciente,5,true)}>Copia título subespecialidad</h3>
                                                                    </>
                                                                    
                                                                :
                                                                    <>
                                                                        <HiOutlineXCircle className='input-icon-inactive' onClick={handleActualizarEntregaDocumento(paciente,5,true)}/>
                                                                        <h3 className="input-document" onClick={handleOpenImageView(paciente,5,false)}>Copia título subespecialidad</h3>
                                                                    </>
                                                                    
                                                            }
                                                            
                                                        </div>
                                                        <div className="input-wrapper">
                                                            {
                                                                paciente.copy_specialty_board_certification
                                                                ?
                                                                    <>
                                                                        <HiOutlineCheckCircle className='input-icon' onClick={handleActualizarEntregaDocumento(paciente,13,false)}/>
                                                                        <h3 className="input-document" onClick={handleOpenImageView(paciente,13,true)}> Copia de la Certificación de consejo de especialidad de ambos lados vigente</h3>
                                                                    </>
                                                                    
                                                                :
                                                                    <>
                                                                        <HiOutlineXCircle className='input-icon-inactive' onClick={handleActualizarEntregaDocumento(paciente,13,true)}/>
                                                                        <h3 className="input-document" onClick={handleOpenImageView(paciente,13,false)}> Copia de la Certificación de consejo de especialidad de ambos lados vigente</h3>
                                                                    </>
                                                            }
                                                        </div>
                                                        <div className="input-wrapper">
                                                            {
                                                                paciente.copy_of_office_operating_notice
                                                                ?
                                                                    <>
                                                                        <HiOutlineCheckCircle className='input-icon' onClick={handleActualizarEntregaDocumento(paciente,10,false)}/>
                                                                        <h3 className="input-document" onClick={handleOpenImageView(paciente,10,true)}> Copia del Aviso de funcionamiento de consultorio</h3>
                                                                    </>
                                                                    
                                                                :
                                                                    <>
                                                                        <HiOutlineXCircle className='input-icon-inactive' onClick={handleActualizarEntregaDocumento(paciente,10,true)}/>
                                                                        <h3 className="input-document" onClick={handleOpenImageView(paciente,10,false)}> Copia del Aviso de funcionamiento de consultorio</h3>
                                                                    </>
                                                            }
                                                        </div>
                                                        <div className="input-wrapper">
                                                            {
                                                                paciente.copy_state_registry_of_professions
                                                                ?
                                                                    <>
                                                                        <HiOutlineCheckCircle className='input-icon' onClick={handleActualizarEntregaDocumento(paciente,11,false)}/>
                                                                        <h3 className="input-document" onClick={handleOpenImageView(paciente,11,true)}> Copia del Registro Estatal de Profesiones</h3>
                                                                    </>
                                                                    
                                                                :
                                                                    <>
                                                                        <HiOutlineXCircle className='input-icon-inactive' onClick={handleActualizarEntregaDocumento(paciente,11,true)}/>
                                                                        <h3 className="input-document" onClick={handleOpenImageView(paciente,11,false)}> Copia del Registro Estatal de Profesiones</h3>
                                                                    </>
                                                            }
                                                        </div>
                                                    </>
                                                :
                                                    null
                                        }
                                    
                                    <div className="input-wrapper">
                                        {
                                            clicContanciasSelect
                                                ?
                                                    <span id="buildingDownArrow" className="input-icon-drop" onClick={mostrarOcultarConstancias}><AiFillCaretUp/></span>
                                                :
                                                    <span id="buildingDownArrow" className="input-icon-drop" onClick={mostrarOcultarConstancias}><AiFillCaretDown/></span>
                                        }
                                        <h3 className="input-document-group" >Constancias de cursos o congresos</h3>
                                    </div>
                                        {
                                            clicContanciasSelect
                                                ?
                                                    <>
                                                        <div className="input-wrapper">
                                                            {
                                                                mostrarSelectorImagenConstanciaUno
                                                                    ?
                                                                        <>
                                                                            <HiOutlineCheckCircle className='input-icon' onClick={handleActualizarEntregaDocumento(paciente,14,false)}/>
                                                                            <h3 className="input-document" onClick={handleOpenImageView(paciente,14,true)}>{constanciaUnoName}</h3>
                                                                        </>
                                                                        
                                                                    :
                                                                        <>
                                                                            <HiOutlineXCircle className='input-icon-inactive' onClick={handleActualizarEntregaDocumento(paciente,14,true)}/>
                                                                            <h3 className="input-document" onClick={handleOpenImageView(paciente,14,false)}>{constanciaUnoName}</h3>
                                                                        </>
                                                                        
                                                            }
                                                        </div>
                                                        <div className="input-wrapper">
                                                            {
                                                                mostrarSelectorImagenConstanciaDos
                                                                    ?
                                                                        <>
                                                                            <HiOutlineCheckCircle className='input-icon' onClick={handleActualizarEntregaDocumento(paciente,15,false)}/>
                                                                            <h3 className="input-document" onClick={handleOpenImageView(paciente,15,true)}>{constanciaDosName}</h3>
                                                                        </>
                                                                        
                                                                    :
                                                                        <>
                                                                            <HiOutlineXCircle className='input-icon-inactive' onClick={handleActualizarEntregaDocumento(paciente,15,true)}/>
                                                                            <h3 className="input-document" onClick={handleOpenImageView(paciente,15,false)}>{constanciaDosName}</h3>
                                                                        </>
                                                                        
                                                            }
                                                        </div>
                                                        <div className="input-wrapper">
                                                            {
                                                                mostrarSelectorImagenConstanciaTres
                                                                    ?
                                                                        <>
                                                                            <HiOutlineCheckCircle className='input-icon' onClick={handleActualizarEntregaDocumento(paciente,16,false)}/>
                                                                            <h3 className="input-document" onClick={handleOpenImageView(paciente,16,true)}>{constanciaTresName}</h3>
                                                                        </>
                                                                        
                                                                    :
                                                                        <>
                                                                            <HiOutlineXCircle className='input-icon-inactive' onClick={handleActualizarEntregaDocumento(paciente,16,true)}/>
                                                                            <h3 className="input-document" onClick={handleOpenImageView(paciente,16,false)}>{constanciaTresName}</h3>
                                                                        </>
                                                                        
                                                            }
                                                        </div>
                                                        <div className="input-wrapper">
                                                            {
                                                                mostrarSelectorImagenConstanciaCuatro
                                                                    ?
                                                                        <>
                                                                            <HiOutlineCheckCircle className='input-icon' onClick={handleActualizarEntregaDocumento(paciente,17,false)}/>
                                                                            <h3 className="input-document" onClick={handleOpenImageView(paciente,17,true)}>{constanciaCuatroName}</h3>
                                                                        </>
                                                                        
                                                                    :
                                                                        <>
                                                                            <HiOutlineXCircle className='input-icon-inactive' onClick={handleActualizarEntregaDocumento(paciente,17,true)}/>
                                                                            <h3 className="input-document" onClick={handleOpenImageView(paciente,17,false)}>{constanciaCuatroName}</h3>
                                                                        </>
                                                                        
                                                            }
                                                        </div>
                                                        <div className="input-wrapper">
                                                            {
                                                                mostrarSelectorImagenConstanciaCinco
                                                                    ?
                                                                        <>
                                                                            <HiOutlineCheckCircle className='input-icon' onClick={handleActualizarEntregaDocumento(paciente,18,false)}/>
                                                                            <h3 className="input-document" onClick={handleOpenImageView(paciente,18,true)}>{constanciaCincoName}</h3>
                                                                        </>
                                                                        
                                                                    :
                                                                        <>
                                                                            <HiOutlineXCircle className='input-icon-inactive' onClick={handleActualizarEntregaDocumento(paciente,18,true)}/>
                                                                            <h3 className="input-document" onClick={handleOpenImageView(paciente,18,false)}>{constanciaCincoName}</h3>
                                                                        </>
                                                                        
                                                            }
                                                        </div>
                                                    </>
                                                :
                                                    null
                                        }
                                    
                                    
                                    
                                    
                                    {
                                        paciente.active
                                            ?
                                                <h1 className='info_itemblog'>{"Vigente"}</h1>
                                            :
                                                <h1 className='info_itemblog'>{"Inactivo"}</h1>
                                    }
                                    {/* <h1 className='info_item_hospital_name'>{getUnidadHospitalariaName(unidadHospitalariaNombre,uhList)}</h1> */}
                                    {/* <QrCode className='info_itemblog' qrvalue={paciente.curp}/> */}
                                    <br></br>
                                    {
                                        puedeEditar && !isReadOnly
                                            ?
                                                <p className='boton_uno' onClick={handleActualizarCredencial(paciente)}>Actualizar</p>
                                            :
                                                null
                                    }
                                    {
                                        paciente.photo
                                            ?
                                                <>
                                                    <br></br>
                                                    <p className='boton_uno' onClick={handleVisualizarCredencial(paciente)}>Credencial</p>
                                                </>
                                                
                                            :
                                                null
                                    }
                                    <br></br>
                                    {
                                        puedeEditar  && !isReadOnly
                                            ?
                                                <p className='boton_delete' onClick={handleEliminarCredencial(paciente)}>Eliminar</p>
                                            :
                                                null
                                    }
                                    
                                </div>
                            </div>
                        </>
                    )
                :
                    null
            }
            {
                <PacienteModal paciente={pacienteSeleccionado} isVisible={isVisible} hideModal={hideModal} uhList={uhList} 
                unidadHospitalariaNombre={pacienteUH} telefonoIsVisible={pacienteTelefonoIsVisible} 
                isRecuperacion={pacienteIsRecuperacion} setIsVisible={setIsVisible} tieneContactos={pacienteTieneContactos}
                pacienteContactos={pacienteContactos} name={name} isEspecial={pacienteIsEspecial} 
                isRecuperacionOrigen={isRecuperacionOrigen} pacienteUnidadHospitalariaName={pacienteUnidadHospitalariaName}/>
            }
        </>
        
    )
}

export default PacientePendienteAlta